import React from 'react'

const InputLabel = props => {
  const {
    component = 'label',
    htmlFor: name,
    children,
    required = false,
  } = props

  if (component === 'label') {
    return (
      <label className="block font-medium text-gray-900" htmlFor={name}>
        {children} {required && <span className="text-red-600">*</span>}
      </label>
    )
  }

  return (
    <legend className="font-medium text-gray-900">
      {children} {required && <span className="text-red-600">*</span>}
    </legend>
  )
}

export default InputLabel
